<div class="banner-container">
  <cre-spinner
    [size]="'md'"
    [hidden]="!isLoading"
    class="banner-spinner"
  ></cre-spinner>
  <div *ngIf="(!isLoading && errorToShow != null)" class="banner-content">
    <div class="no-team">
      <span>{{ errorToShow }}</span>
    </div>
  </div>
  <div *ngIf="(!isLoading && errorToShow == null)" class="banner-content">
    <div class="banner-logo-left">
      <div
        class="banner-league-logo"
        [ngStyle]="{ 'background-image': 'url(' + leagueLogoUrl + ')' }"
      ></div>
    </div>
    <div class="banner-center">
      <div class="cr-england-horizontal">
      </div>
      <div class="banner-team"><span>Team: {{ driverInformation.teamFleet }}</span> </div>
      <div *ngIf="(!!driverInformation.teamNickname)" class="banner-nickname"><span>Team {{ driverInformation.teamNickname }}</span></div>
      <div class="banner-weekend"><span>Week Ending {{ monthToShow }} {{ dateToShow }}</span> </div>
    </div>
    <div class="banner-logo-right">
      <div
        class="banner-fleet-logo"
        [ngStyle]="{ 'background-image': 'url(' + fleetLogoUrl + ')' }"
      ></div>
    </div>
  </div>
</div>
